import { render, staticRenderFns } from "./NotificationMy.vue?vue&type=template&id=3ad94cb6&scoped=true&"
import script from "./NotificationMy.vue?vue&type=script&lang=js&"
export * from "./NotificationMy.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMy.vue?vue&type=style&index=0&id=3ad94cb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad94cb6",
  null
  
)

export default component.exports